import { render, staticRenderFns } from "./ViewRecall.vue?vue&type=template&id=ff062842&scoped=true&"
import script from "./ViewRecall.vue?vue&type=script&lang=js&"
export * from "./ViewRecall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff062842",
  null
  
)

export default component.exports